import { useEffect } from 'react';
import { useFeedStore } from '@lib/store';
import { cn } from '@shared/utils';
import { PageLayout } from '@shared/widgets';
import styles from './info.module.css';

export const FaqPage = () => {
  const feedStore = useFeedStore();

  useEffect(() => {
    feedStore.getFeed(1);
  }, []);

  return (
    <PageLayout>
      <div className='mx-auto w-[1440px] max-md:w-auto'>
        <div className='relative mt-[90px]'>
          <div className='h-[1px] w-[140px] bg-[#272727] max-md:hidden' />
          <h2 className='ml-6 font-[Prata] text-[56px] text-[#272727] max-md:mx-auto max-md:text-[28px]'>FAQ`s</h2>
        </div>
        <div className='mt-[50px] mb-[176px] flex justify-between max-md:m-0 max-md:px-4'>
          <div
            dangerouslySetInnerHTML={{ __html: feedStore.data as unknown as string | TrustedHTML }}
            className={cn('mx-[164px] columns-2 gap-x-[10%] max-md:m-0 max-md:columns-1', styles.content)}
          />
        </div>
      </div>
    </PageLayout>
  );
};
